/**
 * Formata horas decimais em formato "Xh Ym"
 * Exemplos:
 *   29.5  → +29h30m
 *   -5.75 → -5h45m
 *   10.0  → +10h
 *   0.5   → +30m
 *   0     → 0h
 *   6.666... → +6h40m (férias/baixas)
 */
export const formatarHoras = (horasDecimal) => {
  if (horasDecimal === 0 || horasDecimal === '0') return '0h';
  
  let valor = typeof horasDecimal === 'string' ? parseFloat(horasDecimal) : horasDecimal;
  if (isNaN(valor)) return '0h';
  
  const negativo = valor < 0;
  const horasAbs = Math.abs(valor);
  const horas = Math.floor(horasAbs);
  const minutosExatos = Math.round((horasAbs - horas) * 60);
  
  // Arredondar para múltiplos de 15 minutos (consistente com backend)
  // Mas preservar 40m para férias/baixas (6h40m)
  let minutos = minutosExatos;
  
  // Preservar valores específicos: 40m (férias/baixas), 45m, 30m, 15m
  const valoresPermitidos = [0, 15, 30, 40, 45];
  
  if (!valoresPermitidos.includes(minutos)) {
    // Encontrar o valor permitido mais próximo
    let menorDiferenca = 60;
    let melhorValor = 0;
    for (const v of valoresPermitidos) {
      const diff = Math.abs(minutos - v);
      if (diff < menorDiferenca) {
        menorDiferenca = diff;
        melhorValor = v;
      }
    }
    minutos = melhorValor;
  }
  
  // Ajustar se passou para 60
  let horasFinal = horas;
  if (minutos >= 60) {
    horasFinal += 1;
    minutos = 0;
  }
  
  let resultado = `${horasFinal}h`;
  if (minutos > 0) {
    resultado += `${minutos}m`;
  }
  
  return negativo ? `-${resultado}` : `+${resultado}`;
};

/**
 * Formata horas SEM o sinal + ou -
 */
export const formatarHorasSemSinal = (horasDecimal) => {
  const formatado = formatarHoras(horasDecimal);
  return formatado.replace(/^[+-]/, '');
};
